;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { Dispatch, SetStateAction, ChangeEvent } from "react"
import { UI_STYLE_PRIMARY_BLUE_BLACK } from "../../../../lib/constants"
import FormGroup from "@mui/material/FormGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"

type StyledCheckboxProps = {
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const StyledCheckbox = ({ checked, onChange }: StyledCheckboxProps) => {
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      color="primary"
      sx={{
        "&.MuiCheckbox-colorPrimary.Mui-checked": {
          color: UI_STYLE_PRIMARY_BLUE_BLACK,
        },
        "&:not(.Mui-checked)": {
          color: "#AAAAAA",
        },
      }}
    />
  )
}

const StyledFormControlLabel = ({
  control,
  label,
  highlightLabel,
}: {
  control: React.ReactElement
  label: string
  highlightLabel?: boolean
}) => {
  return (
    <FormControlLabel
      control={control}
      label={label}
      sx={{
        alignItems: "flex-start",
        marginRight: 0,
        "& .MuiFormControlLabel-label": {
          fontSize: "16px",
          marginLeft: "10px",
          marginTop: "10px",
          borderRadius: "3px",
          backgroundColor: highlightLabel ? "#E4FF3F" : "unset",
        },
      }}
    />
  )
}

type Props = {
  consultRequiredAcknowledge: boolean
  setConsultRequiredAcknowledge: Dispatch<SetStateAction<boolean>>
  stateResidenceRequiredAcknowledge: boolean
  setStateResidenceRequiredAcknowledge: Dispatch<SetStateAction<boolean>>
  consultRequired: boolean
  requiredToResideInStatesArray: string[]
}

export default function AttendanceRequirements({
  consultRequiredAcknowledge,
  setConsultRequiredAcknowledge,
  stateResidenceRequiredAcknowledge,
  setStateResidenceRequiredAcknowledge,
  consultRequired,
  requiredToResideInStatesArray,
}: Props) {
  const handleRequiredToResideInStatesChange = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    setStateResidenceRequiredAcknowledge(event.target.checked)
  }

  const handleConsultRequiredChange = (event: ChangeEvent<HTMLInputElement>) => {
    setConsultRequiredAcknowledge(event.target.checked)
  }

  const renderRequiredToResideInStates = () => {
    const checkboxText =
      requiredToResideInStatesArray.length === 1
        ? `I am a resident of the state of ${requiredToResideInStatesArray}.`
        : `I am a resident of one of the following states: ${requiredToResideInStatesArray.join(", ")}.`

    return (
      <StyledFormControlLabel
        control={
          <StyledCheckbox
            checked={stateResidenceRequiredAcknowledge}
            onChange={handleRequiredToResideInStatesChange}
          />
        }
        label={checkboxText}
        key={"stateResidenceRequired"}
      />
    )
  }

  const renderConsultRequired = () => {
    return (
      <StyledFormControlLabel
        control={
          <StyledCheckbox
            checked={consultRequiredAcknowledge}
            onChange={handleConsultRequiredChange}
          />
        }
        label={`I agree to a consultation and to share my contact details with the group leader.`}
        key={"consultRequired"}
      />
    )
  }

  const attendanceRequirementChecklist: React.ReactNode[] = []

  if (requiredToResideInStatesArray.length > 0) {
    attendanceRequirementChecklist.push(renderRequiredToResideInStates())
  }
  if (consultRequired) {
    attendanceRequirementChecklist.push(renderConsultRequired())
  }

  return attendanceRequirementChecklist.length > 0 ? (
    <div className="mb-[33px]">
      <FormGroup>{attendanceRequirementChecklist}</FormGroup>
    </div>
  ) : null
}
